export default __webpack_public_path__ + "static/media/purple-remove-icon.19b06138.svg";